<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">

            <x-form-group label="Label"
                :error="getError('label')"
                :is-required="true">
                <input type="text"
                    class="form-control"
                    v-model="fields.label"
                    required />
            </x-form-group>

            <x-form-group label="Role Default"
                :error="getError('is_default')">
                <x-checkbox-wrapper label="Otomatis gunakan role ini untuk pengguna baru">
                    <input type="checkbox"
                        v-model="fields.is_default" />
                </x-checkbox-wrapper>
            </x-form-group>

            <x-form-group label="Akses"
                :error="getError('permissions')"
                :is-required="true">
                <x-filter-box v-for="group in permissionGroups" 
                    :key="group.key"
                    :title="group.label"
                    :readonly="true"
                    :help-text="null"
                    :id="group.key">
                    <template #subtitle v-if="!disabled">
                        <a v-if="groupHasNoAccess(group)" 
                            href="javascript:;" 
                            title="Klik untuk beri akses penuh"
                            @click="giveGroupFullAccess(group)">
                            <i class="fa fa-square-o" /> Beri akses penuh
                        </a>
                        <a v-else 
                            href="javascript:;" 
                            title="Klik untuk hapus semua akses"
                            @click="restrictAllGroupAccess(group)">
                            <i :class="{
                                'fa': true, 
                                'fa-check-square-o': groupHasFullAccess(group),
                                'fa-square': groupHasPartialAccess(group),
                            }" /> Hapus semua akses
                        </a>
                    </template>
                    <x-filter-box v-for="(permission, index) in group.permissions" 
                        :key="`${group.key}-${index}`"
                        :title="permission.label"
                        :readonly="true"
                        :help-text="null"
                        :id="`${group.key}-${index}`">
                        <template #subtitle v-if="!disabled">
                            <a v-if="permissionHasNoAccess(permission)" 
                                href="javascript:;" 
                                title="Klik untuk beri akses penuh"
                                @click="givePermissionFullAccess(permission)">
                                <i class="fa fa-square-o" /> Beri akses penuh
                            </a>
                            <a v-else 
                                href="javascript:;" 
                                title="Klik untuk hapus semua akses"
                                @click="restrictAllPermissionAccess(permission)">
                                <i :class="{
                                    'fa': true, 
                                    'fa-check-square-o': permissionHasFullAccess(permission),
                                    'fa-square': permissionHasPartialAccess(permission),
                                }" /> Hapus semua akses
                            </a>
                        </template>
                        <x-checkbox-wrapper v-for="(access, subIndex) in permission.items"     
                            :key="`${group.key}-${index}-${subIndex}`"
                            :label="access.label">
                            <input type="checkbox" 
                                v-model="fields.permissions"
                                :value="access.key"
                                @change="handleToggle(access)" />
                            <template #description v-if="access.description">
                                <span class="help-block">
                                    {{ access.description }}
                                </span>
                            </template>
                        </x-checkbox-wrapper>
                    </x-filter-box>
                </x-filter-box>
            </x-form-group>

        </fieldset>
    </form>
</template>

<script>
import XCheckboxWrapper from '../../components/XCheckboxWrapper.vue'
import XFilterBox from '../../components/XFilterBox.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import { handleGeneralXhrError } from '../../helpers'
import FormErrorMixin from '../../mixins/FormErrorMixin'

export default {
    components: {
        XFormGroup,
        XFilterBox,
        XCheckboxWrapper,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        }
        if (this.fields.permissions === null) {
            this.fields.permissions = []
        }
        this.fetchPermissions()
    },
    data() {
        return {
            fields: {
                label: null,
                permissions: [],
            },
            isLoading: false,
            permissionGroups: [],
        }
    },
    methods: {
        fetchPermissions() {
            this.isLoading = true
            const request = axios.get('/api/user-roles/permission-groups')
                .then(response => {
                    this.permissionGroups = response.data.data
                })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        giveGroupFullAccess(group) {
            group.permissions.forEach(permission => {
                this.givePermissionFullAccess(permission)
            })
        },
        givePermissionFullAccess(permission) {
            permission.items.filter(access => {
                return !Boolean(access.restricted)
            }).forEach(access => {
                if (!this.fields.permissions.includes(access.key)) {
                    this.fields.permissions.push(access.key)
                }
            })
        },
        groupHasFullAccess(group) {
            let hasFullAccess = true
            group.permissions.forEach(permission => {
                hasFullAccess = (hasFullAccess && this.permissionHasFullAccess(permission))
            })
            return hasFullAccess
        },
        groupHasNoAccess(group) {
            let groupHasNoAccess = true
            const permissions = group.permissions
            for (let pKey in permissions) {
                const permission = permissions[pKey]
                for (let key in permission.items) {
                    const access = permission.items[key]
                    if (this.fields.permissions.includes(access.key)) {
                        groupHasNoAccess = false
                    }
                }
            }
            return groupHasNoAccess
        },
        groupHasPartialAccess(group) {
            if (this.groupHasFullAccess(group)) {
                return false
            }
            const permissions = group.permissions
            for (let pKey in permissions) {
                const permission = permissions[pKey]
                for (let key in permission.items) {
                    const access = permission.items[key]
                    if (this.fields.permissions.includes(access.key)) {
                        return true
                    }
                }
            }
            return false
        },
        handleSubmit() {
            this.$emit('submit', this.fields)
        },
        handleToggle(access) {
            const toggles = _.get(access, 'toggles', [])
            this.fields.permissions = this.fields.permissions.filter(choice => {
                return !toggles.includes(choice)
            })
        },
        permissionHasFullAccess(permission) {
            let hasFullAccess = true
            for (let key in permission.items) {
                const access = permission.items[key]
                if (Boolean(access.restricted)) {
                    continue
                }
                if (!this.fields.permissions.includes(access.key)) {
                    hasFullAccess = false
                }
            }
            return hasFullAccess
        },
        permissionHasNoAccess(permission) {
            let hasNoAccess = true
            for (let key in permission.items) {
                const access = permission.items[key]
                if (this.fields.permissions.includes(access.key)) {
                    hasNoAccess = false
                }
            }
            return hasNoAccess
        },
        permissionHasPartialAccess(permission) {
            if (this.permissionHasFullAccess(permission)) {
                return false
            }
            for (let key in permission.items) {
                const access = permission.items[key]
                if (this.fields.permissions.includes(access.key)) {
                    return true
                }
            }
        },
        restrictAllGroupAccess(group) {
            let forbidden = []
            group.permissions.forEach(permission => {
                permission.items.forEach(access => {
                    forbidden.push(access.key)
                })
            })
            this.fields.permissions = this.fields.permissions.filter(choice => {
                return !forbidden.includes(choice)
            })
        },
        restrictAllPermissionAccess(permission) {
            let forbidden = []
            permission.items.forEach(access => {
                forbidden.push(access.key)
            })
            this.fields.permissions = this.fields.permissions.filter(choice => {
                return !forbidden.includes(choice)
            })
        },
    },
    mixins: [
        FormErrorMixin,
    ],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
}
</script>